import axios from '../utils/axios';

// EN-812: `reveal` lets this score spend the account's free reveals; the panel sends it while
// open. A fetch with it off shows what was already revealed and spends nothing.
export const getResumeScore = async (resumeUuid, { reveal = false } = {}) => {
	const response = await axios.get(`/api/resumes/${resumeUuid}/score`, { params: reveal ? { reveal: 1 } : {} });

	return response.data;
};

// EN-796: covered job titles a resume can be scored against — distinct
// specializations with at least one frozen job title profile.
export const getTargetTitles = async () => {
	const response = await axios.get('/api/target-titles');

	return response.data.data;
};

// EN-796: sets or changes the resume's target title/level/track selection.
// EN-814: pass either a catalog `specialization` or an "Other" `title`, not both.
export const setTargetSelection = async (resumeUuid, { specialization, title, level, track }) => {
	const response = await axios.post(`/api/resumes/${resumeUuid}/score/target-selection`, {
		specialization,
		title,
		level,
		track,
	});

	return response.data;
};

// EN-1146: one rewrite of the bullet a Content Strength card points at, aimed at that card's issue.
// Spends a bullet generation credit (429 when a free account has none left) and saves nothing.
export const rewriteBullet = async (resumeUuid, { type, anchor, text }) => {
	const response = await axios.post(`/api/resumes/${resumeUuid}/score/rewrite`, { type, anchor, text });
	return response.data.data;
};
